import gql from 'graphql-tag';

const diccionarioTableQuery = gql`
    query diccionarioDatos($numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        diccionarioDatos(first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                codigo,
                descripcion,
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`

const queries = { diccionarioTableQuery };

export default queries;
